import catalog from '../../../city_game/static/city_game/assets/avatars/character-customization-v1.json';

export const CHARACTER_CATALOG=catalog;
export type CharacterBody='man'|'woman';
export type CharacterAppearance={body:CharacterBody;hair:string;top:string;pants:string;shoes:string;beard:string;moustache:string;hairColor:string;topColor:string;pantsColor:string;shoesColor:string;facialColor:string};
export type CharacterPart={id:string;version?:number;tint?:[number,number,number];tintMode?:'add';tints?:Array<[number,number,number]>};
export function defaultCharacterAppearance(body:CharacterBody='man'):CharacterAppearance{
 return {...catalog.defaults,body,hair:catalog.hair[body][0].id};
}
export function normalizeCharacterAppearance(raw:Partial<CharacterAppearance>):CharacterAppearance{
 const body=raw.body==='woman'?'woman':'man';const result=defaultCharacterAppearance(body);
 for(const field of Object.keys(result) as Array<keyof CharacterAppearance>){
  if(field==='body')continue;
  const choices=field.endsWith('Color')?catalog.colors:field==='hair'?catalog.hair[body]:catalog[field as 'top'|'pants'|'shoes'|'beard'|'moustache'];
  if(choices.some(c=>c.id===raw[field]))result[field]=raw[field]!;
 }
 return result;
}
export function characterKey(appearance:CharacterAppearance):string{
 const a=normalizeCharacterAppearance(appearance);return [catalog.version,...Object.keys(catalog.defaults).map(field=>a[field as keyof CharacterAppearance])].join(':');
}
function tint(color:string):[number,number,number]{
 const hex=catalog.colors.find(c=>c.id===color)!.hex.slice(1);return [0,2,4].map(i=>parseInt(hex.slice(i,i+2),16)/255) as [number,number,number];
}
export function characterParts(appearance:CharacterAppearance):CharacterPart[]{
 const a=normalizeCharacterAppearance(appearance);
 if(a.body==='woman'){
  const parts:CharacterPart[]=[{id:'body-woman',version:1},{id:'hair-'+a.hair,version:1,tint:tint(a.hairColor)}];
  for(const field of ['top','pants','shoes'] as const)parts.push({id:field+'-'+a[field],version:1,tint:tint(a[(field+'Color') as 'topColor'|'pantsColor'|'shoesColor'])});
  for(const field of ['beard','moustache'] as const)if(a[field]!=='none')parts.push({id:field+'-'+a[field],version:1,tint:tint(a.facialColor)});
  return parts;
 }
 const parts:CharacterPart[]=[{id:`outfit-${a.top}-${a.pants}-${a.shoes}`,tints:[tint(a.topColor),tint(a.pantsColor),tint(a.shoesColor)]},{id:'hair-'+a.hair,tint:tint(a.hairColor),tintMode:'add'}];
 for(const field of ['beard','moustache'] as const)if(a[field]!=='none')parts.push({id:field+'-'+a[field],tint:tint(a.facialColor)});
 return parts;
}
